import React, { memo } from 'react';
export function SolutionSection() {
  const steps = [{
    number: '1',
    title: 'Pick the kind of photo you want',
    desc: 'Portraits. Action shots. Cozy indoor moments. Outdoor memories. Seasonal photos. Personality shots.'
  }, {
    number: '2',
    title: 'Follow the simple step-by-step guidance',
    desc: 'Learn exactly how to use light, angles, movement, expression, and composition in a way that actually makes sense.'
  }, {
    number: '3',
    title: "Take photos you'll actually love.",
    desc: 'No overthinking. No technical overload. No guessing every time you open your camera.'
  }];
  return <section className="bg-warm-light py-16 md:py-24 px-4" data-id="element-274">
      <div className="max-w-3xl mx-auto" data-id="element-275">
        {/* Solution badge */}
        <div className="text-center mb-4" data-id="element-276">
          <span className="inline-block bg-green-100 text-green-800 font-sans font-bold text-sm px-4 py-1.5 rounded-full" data-id="element-277">
            ✅ THE SOLUTION
          </span>
        </div>

        {/* Headline */}
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-center text-warm-hero mb-4 leading-tight" data-id="element-278">
          The <span className="italic text-soft-gold" data-id="element-279">Pawfect</span> Shot
          MegaPack
        </h2>

        {/* Subheadline */}
        <p className="font-sans text-lg md:text-xl text-gray-700 text-center mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-280">
          A complete phone dog photography system for everyday dog owners who
          want better photos without overwhelm.
        </p>

        {/* Image placeholder */}
        <div className="mb-12 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-281">
          <img src="https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=900&h=550&fit=crop&crop=faces" alt="Happy dog owner taking a beautiful photo of their dog with a smartphone" className="w-full h-auto object-cover" data-id="element-282" />
        </div>

        {/* How it works */}
        <h3 className="font-serif text-2xl md:text-3xl font-bold text-center text-warm-hero mb-8" data-id="element-283">
          How it works
        </h3>

        <div className="space-y-6 mb-10" data-id="element-284">
          {steps.map(step => <div key={step.number} className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-soft-gold/15 flex items-start gap-5" data-id="element-285">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-soft-gold text-white font-sans font-bold text-lg flex items-center justify-center" data-id="element-286">
                {step.number}
              </div>
              <div data-id="element-287">
                <h4 className="font-sans font-bold text-lg text-warm-hero mb-1" data-id="element-288">
                  {step.title}
                </h4>
                <p className="font-sans text-gray-600 leading-relaxed" data-id="element-289">
                  {step.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* Closing */}
        <p className="font-sans text-lg md:text-xl text-center text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-290">
          Just clear, simple guidance that helps you create dog photos{' '}
          <span className="font-semibold text-warm-hero" data-id="element-291">worth keeping.</span>
        </p>
      </div>
    </section>;
}